import * as OperationTypes from './operations-types';
import introspectionResult from './introspection-result';
const possibleTypes = introspectionResult.possibleTypes;
export { OperationTypes, possibleTypes };
